export const FETCH_LOCATION_SUGGESTIONS = 'FETCH_LOCATION_SUGGESTIONS';
export const CLEAR_LOCATION_SUGGESTIONS = 'CLEAR_LOCATION_SUGGESTIONS';

// CONDOMINIUM PAGE
export const SET_CONDOMINIUM_SORTING = 'SET_CONDOMINIUM_SORTING';

// FILTERS
export const SWITCH_FEATURE_GROUP = 'SWITCH_FEATURE_GROUP';

// AGENCIES
export const FETCH_AGENCY_NEWS = 'FETCH_AGENCY_NEWS';

// UI actions
export const POST_RENTAL_APPLICATION = 'POST_RENTAL_APPLICATION';
export const SET_RENT_FORM_ERROR = 'SET_RENT_FORM_ERROR';
export const POST_BASIC_CONTACT_FORM = 'POST_BASIC_CONTACT_FORM';
export const RESET_CONTACT_FORM_RESULTS = 'RESET_CONTACT_FORM_RESULTS';
export const POST_MEDIA_CONTACT = 'POST_MEDIA_CONTACT';
export const POST_CALCULATOR_FEEDBACK_CONTACT = 'POST_CALCULATOR_FEEDBACK_CONTACT';

// LISTING PAGE
export const UNSUBSCRIBE = 'UNSUBSCRIBE';

// ERRORS
export const SET_ERROR_PAGE_DATA = 'SET_ERROR_PAGE_DATA';

// PRICE CALCULATOR
export const GET_PRICE_PREDICTIONS = 'GET_PRICE_PREDICTIONS';

// ANALYTICS
export const analytics = {
  track: 'TRACK',
  init: 'INIT_DATALAYER',
  set: 'SET_DATALAYER',
  append: 'APPEND_TO_DATALAYER',
  save: 'SAVE_DATALAYER',
  saveString: 'SAVE_ANALYTICS_STRING',
  suspend: 'SUSPEND_ANALYTICS_CALLS',
  ocmBannerReady: 'OCM_BANNER_READY',
};

// REGIONS
export const FETCH_POSTAL_CODE_SUGGESTIONS = 'FETCH_POSTAL_CODE_SUGGESTIONS';
